import { render, staticRenderFns } from "./ConfigDowntime.vue?vue&type=template&id=00c5d5e4&scoped=true&"
import script from "./ConfigDowntime.vue?vue&type=script&lang=js&"
export * from "./ConfigDowntime.vue?vue&type=script&lang=js&"
import style0 from "./ConfigDowntime.vue?vue&type=style&index=0&id=00c5d5e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c5d5e4",
  null
  
)

export default component.exports